import React, { useEffect } from 'react';

import {
    useHistory
} from "react-router-dom";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    paperWrapper: {
        maxWidth: 1024,
        margin: '10px auto',
        '& p': {
            marginBottom: theme.spacing(2)
        }
    }
}));

const CeremonyInstructions = (props) => {
    const classes = useStyles();

    let history = useHistory();

    const {
        couple,
        officiant
    } = props;

    useEffect(() => {
        document.title = 'Couple Instructions - Enduring Promises';
    });

    const bride = couple.bride_first_name;
    const groom = couple.groom_first_name;

    const handleBackClick = () => {
       history.push('/couple')
    };

    return (
        <div className={classes.paperWrapper}>
            <Paper square className={classes.paper}>
                <Typography variant="h5" component="h2" color="textPrimary" gutterBottom={true}>
                    Create your Ceremony
                </Typography>
                <Typography>
                    Welcome {bride} and {groom} to your wedding Ceremony Console.
                </Typography>
                <Typography>
                    This Console will reduce the stress that may be associated with creating your wedding ceremony from scratch. It will also make it easy for you to create a personalized and memorable ceremony, one that is reflective of your personalities and intentions.
                </Typography>
                <Typography>
                    Under all Headings (e.g. Musical Prelude, Guest Greeting & Announcements, etc.), you will see a box titled "View Suggestions". Click on this box and various sample options will appear. Select the wording that best reflects your feelings and desires and click the Add button. Your selection will be added to your ceremony. In your ceremony, you will see your selection has been added, and you can now edit it in any way you wish – mix and match or add wording from a third party source.
                </Typography>
                {officiant &&
                    <Typography>
                        As you work on your ceremony, please Send it to {officiant.first_name}, who will add some directions and questions and advise you by email to review his/her comments. If at any time you require assistance, contact {officiant.first_name} who will get back to you as soon as possible.
                    </Typography>
                }
                <Typography>
                    <strong>Remember to click "Save" after each edit. Due to the proprietary nature of this template, we strongly recommend that you do not use Explorer as your browser but use Chrome or Firefox.</strong>
                </Typography>
            </Paper>
            <Box mt={2}>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleBackClick}
                    endIcon={<Icon>chevron_right</Icon>}
                >
                        View Ceremony
                </Button>
            </Box>
        </div>
    )
}

export default CeremonyInstructions;